// extracted by mini-css-extract-plugin
export default {"buttonBigGray":"buttonBigGray_buttonBigGray__jc8Wz","small":"buttonBigGray_small__57sUT","isDisabled":"buttonBigGray_isDisabled__OGwLH"};